export default __webpack_public_path__ + "static/media/sunset-waves-top.f69494ac.svg";